import { useMemo } from 'react'

//* Style
import FactsStyle from './style'

//* Components
import Container from 'components/common/Container'
import Text from 'components/common/Text'

const Facts = ({ facts, first, title }) => {
	const storeFacts = useMemo(() => {
		const classnamesDifferenceFactsLength = facts.length === 4 ? 'col-3 col-ds-6 col-m-12' : 'three-facts col-4 col-t-6 col-m-12'

		return facts.map((fact, index) => (
			<div key={index} className={`fact-wrap ${classnamesDifferenceFactsLength}`}>
				<div className='fact'>
					<Text className={'h4 font-soundscape-bold primaryColor2'} text={`0${index + 1}`} />
					<Text tag={'h3'} className={'title font-ping-bold h6 primaryColor1'} text={fact.title} />
					<Text className={'p primaryColor1 font-helvetica'} text={fact.description} />
				</div>
			</div>
		))
	}, [facts])

	return (
		<FactsStyle>
			{title && (
				<Container>
					<Text tag={'h2'} className={'h3 main-title font-ping-bolder'} text={title} />
				</Container>
			)}
			<Container first={first} row section className='facts-container'>
				{storeFacts}
			</Container>
		</FactsStyle>
	)
}

export default Facts
